<div class="wrapper">
  <div class="container mt-5">
    <div class="card shadow-sm">
      <div class="card-header text-center">
        <h4>{{ config.heading || 'Service Provider Details' }}</h4>
      </div>
      <div class="card-body">
        <p><strong>Name:</strong> {{ data.data.Owner?.name || config?.defaultTitle || 'Software Developer' }}</p>
        <p><strong>Company:</strong> {{ data.data?.serviceType || config?.defaultCompany || 'Tech Solutions' }}</p>
        <p><strong>Iamge:</strong> {{ data.data.workExperience?.image || config?.defaultLocation || 'New York, USA' }}</p>
        <p><strong>Service Category:</strong> {{ data.data?.category || config?.defaultExperience || '2+ years' }}</p>
        <p><strong>Posted On:</strong> {{ data.data?.created || config?.defaultPostedOn || 'January 29, 2025' }}</p>

        <div class="mt-4">
          <h5>{{ config?.descriptionTitles || 'Service Description' }}</h5>
          <p>
            {{ data.data.workExperience?.description || config?.defaultDescription || 'We are looking for a skilled Software Developer with experience in Angular and web development. You will work with a team of developers to build high-quality applications.' }}
          </p>
        </div>

        <div class="d-flex justify-content-center mt-3">
          <button (click)="getService()" class="btn btn-success mx-2">
            {{ config?.getServiceText || 'Get Service' }}
          </button>
          <button (click)="redirectToServiceProvider()" class="btn btn-secondary mx-2">
            {{ config?.viewProviderText || 'View Service Provider' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
